import { render, staticRenderFns } from "./BipSchools.vue?vue&type=template&id=379c4807&scoped=true&"
import script from "./BipSchools.vue?vue&type=script&lang=js&"
export * from "./BipSchools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379c4807",
  null
  
)

export default component.exports